import { PagePayload } from '@core/interface/core';
import {
  FormResponse,
  FormError,
  FormItem,
  AddformResponse,
  FormHeaderPayload,
  FormHeaderResponse,
  FormDataPayload,
  FormDetailsResponse,
  TicksheetListResponse,
  TicksheetDataResponse,
  TicksheetSubmitPayload,
  FormCommonResponse,
  UpdateRowPayload,
  UpdateTicksheetDetailsPayload,
  UpdateTicksheetDetailsResponse,
  AddRowPayload,
  SorOptionsResponse,
} from '@core/interface/ticksheet';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TicksheetActions = createActionGroup({
  source: 'Ticksheet',
  events: {
    'Load Ticksheet Forms': props<PagePayload>(),
    'Load Ticksheet Forms Success': props<FormResponse>(),
    'Load Ticksheet Forms Failure': props<FormError>(),
    'Add Edit Ticksheet': props<FormDataPayload>(),
    'Add Ticksheet Success': props<AddformResponse>(),
    'Add Ticksheet Failure': props<FormError>(),
    'Create Form Header': props<FormHeaderPayload>(),
    'Create Form Header Success': props<FormHeaderResponse>(),
    'Create Form Header Failure': props<FormError>(),
    'Load Form Details': props<{ id: number }>(),
    'Load Form Details Success': props<FormDetailsResponse>(),
    'Load Form Details Failure': props<FormError>(),
    'Reset Form Flag': emptyProps(),
    'Reset Ticksheet Form data': emptyProps(),
    'Load Ticksheets': props<PagePayload>(),
    'Load Ticksheets Success': props<TicksheetListResponse>(),
    'Load Ticksheets Failure': props<FormError>(),
    'Load Checked Ticksheets': props<PagePayload>(),
    'Load Checked Ticksheets Success': props<TicksheetListResponse>(),
    'Load Checked Ticksheets Failure': props<FormError>(),
    'Load Ticksheet Details': props<{ tick_sheet_id: number }>(),
    'Load Ticksheet Details Success': props<TicksheetDataResponse>(),
    'Load Ticksheet Details Failure': props<FormError>(),
    'Update Ticksheet Row': props<UpdateRowPayload>(),
    'Update Ticksheet Row Success': props<FormCommonResponse>(),
    'Update Ticksheet Row Failure': props<FormError>(),
    'Add Ticksheet Row': props<AddRowPayload>(),
    'Add Ticksheet Row Success': props<FormCommonResponse>(),
    'Add Ticksheet Row Failure': props<FormError>(),
    'Update Ticksheet details': props<UpdateTicksheetDetailsPayload>(),
    'Update Ticksheet details Success': props<UpdateTicksheetDetailsResponse>(),
    'Update Ticksheet details Failure': props<FormError>(),
    'Reset Update Ticksheet details Flag': emptyProps(),
    'Load Sor Options': props<{ tick_sheet_id: number }>(),
    'Load Sor Options Success': props<SorOptionsResponse>(),
    'Load Sor Options Failure': props<FormError>(),
  },
});
